import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

import getRandom from '../util/getRandom';

const INITIAL_STATE = Immutable({
  checklistItemAnswers: [],
  isLoading: false,
});

// api actions
export const onLoadChecklistItemAnswers = createAction(
  'ONLOAD_CHECKLISTITEMANSWERS'
);
export const onSubmitChecklistItemAnswer = createAction(
  'ONSUBMIT_CHECKLISTITEMANSWER'
);
export const onLoadChecklistItemAnswersSucceeded = createAction(
  'ONLOAD_CHECKLISTITEMANSWER_SUCCEEDED'
);
export const onSubmitChecklistItemAnswersSucceeded = createAction(
  'ONSUBMIT_CHECKLISTITEMANSWERS_SUCCEEDED'
);
export const onSubmitChecklistItemAnswers = createAction(
  'ON_SUBMIT_CHECKLISTITEMANSWERS'
);

export const submitChecklistItemAnswer = (state, checklistItemAnswer) => {
  let checklistItemAnswers = state.checklistItemAnswers.asMutable();
  if (
    checklistItemAnswers.some(
      (c) => c.checklistItemId === checklistItemAnswer.checklistItemId
    )
  ) {
    const checklistItemAnswerChangeId = checklistItemAnswers.findIndex(
      (c) => c.checklistItemId === checklistItemAnswer.checklistItemId
    );
    checklistItemAnswers[checklistItemAnswerChangeId] = checklistItemAnswer;
  } else {
    checklistItemAnswers = [...checklistItemAnswers, checklistItemAnswer];
  }
  return state.merge({
    checklistItemAnswers,
  });
};

const reducers = createReducer(
  {
    [onLoadChecklistItemAnswers]: (state) => state.merge({ isLoading: true }),
    [onSubmitChecklistItemAnswer]: submitChecklistItemAnswer,
    [onSubmitChecklistItemAnswers]: (state) => state.merge({ isLoading: true }),
    [onSubmitChecklistItemAnswersSucceeded]: (
      state,
      { checklistItemAnswers }
    ) => state.merge({ isLoading: false, checklistItemAnswers }),
    [onLoadChecklistItemAnswersSucceeded]: (state, { checklistItemAnswers }) =>
      state.merge({
        isLoading: false,
        checklistItemAnswers: checklistItemAnswers.checklistRunAnswers,
      }),
  },
  INITIAL_STATE
);

export default reducers;



// WEBPACK FOOTER //
// ./src/app/reducers/checklistItem.reducers.js